import React, {useEffect, useState} from 'react';
import {getLanguage, t} from 'react-switch-lang';
import SectorInfo from "../../../components/sectorInfo/SectorInfo";
import {Col} from "reactstrap";
import {useParams} from 'react-router-dom';
import {getOverallRiskAssessment} from '../../../../../services/externalizations/externalizationService';

const RiskLevelSum = ({cycleId}) => {
  const [data, setData]= useState()
  const getRiskColor = (value) => {
    switch(value) {
      case 0:
        return '#37C35C';
      case 1:
        return '#F59A1F';
      case 2:
        return '#F5501F';
      default:
        return 'grey';
    }
  };

  useEffect(() => {
    getOverallRiskAssessment(cycleId).then((res) => {
        setData(res?.data);
    })
  }, [cycleId]);
  const getMaxRiskLevelInfo = () => {
    const values = [
      data?.proposalFormRiskAssessmentValue,
      data?.spniftFormRiskAssessmentValue,
      data?.legalFormRiskAssessmentValue,
      data?.itfSecurityFormRiskAssessmentValue,
      data?.financeFormRiskAssessmentValue,
      data?.controllingFormRiskAssessmentValue,
      data?.complianceFormRiskAssessmentValue,
      data?.creditRiskManagementFormRiskAssessmentValue,
      data?.bankRiskProfileFormRiskAssessmentValue
    ].filter(v => typeof v === 'number');
    const maxValue = Math.max(...values, 0);
    if (maxValue === 0) {
      return {
        riskValue: 0,
        riskLevel: t('externalization.lowRiskLevel'),
        riskDescription: t('externalization.riskLevelSum.lowRiskDescription')
      };
    } else if (maxValue === 1) {
      return {
        riskValue: 1,
        riskLevel: t('externalization.mediumRiskLevel'),
        riskDescription: t('externalization.riskLevelSum.mediumRiskDescription')
      };
    } else if (maxValue === 2) {
      return {
        riskValue: 2,
        riskLevel: t('externalization.highRiskLevel'),
        riskDescription: t('externalization.riskLevelSum.highRiskDescription')
      };
    }

    return {
      riskLevel: t('externalization.undefinedRiskLevel'),
      riskDescription: t('externalization.undefinedRiskLevel')
    };
  };
  const lang = getLanguage();
    return (<>
        <div style={{display: 'flex',flexWrap: 'wrap',gap: '20px 0px', paddingRight: '30px',marginTop: '50px'}}>
            <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.firstSectorHeader')}
            riskLevel={lang === 'mne' ? data?.proposalFormRiskAssessment
                        : data?.proposalFormRiskAssessmentEn}
            riskDescription={lang === 'mne' ? data?.proposalFormRiskAssessmentDescription
              : data?.proposalFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.proposalFormRiskAssessmentValue) }}
            />
          </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.secondSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.spniftFormRiskAssessment
                          : data?.spniftFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.spniftFormRiskAssessmentDescription
                          : data?.spniftFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.spniftFormRiskAssessmentValue) }}
            />
        </Col>
        <Col className="col-12">
           <SectorInfo header={t('externalization.riskLevelSum.thirdSectorHeader')}
                       riskLevel={lang === 'mne' ? data?.legalFormRiskAssessment
                         : data?.legalFormRiskAssessmentEn}
                       riskDescription={lang === 'mne' ? data?.legalFormRiskAssessmentDescription
                         : data?.legalFormRiskAssessmentDescriptionEn}
                       style={{ color: getRiskColor(data?.legalFormRiskAssessmentValue) }}
           />
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.fourthSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.itfSecurityFormRiskAssessment
                          : data?.itfSecurityFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.itfSecurityFormRiskAssessmentDescription
                          : data?.itfSecurityFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.itfSecurityFormRiskAssessmentValue) }}/>
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.fifthSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.financeFormRiskAssessment
                          : data?.financeFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.financeFormRiskAssessmentDescription
                          : data?.financeFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.financeFormRiskAssessmentValue) }}
            />
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.sixthSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.controllingFormRiskAssessment
                          : data?.controllingFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.controllingFormRiskAssessmentDescription
                          : data?.controllingFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.controllingFormRiskAssessmentValue) }}
            />
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.seventhSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.complianceFormRiskAssessment
                          : data?.complianceFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.complianceFormRiskAssessmentDescription
                          : data?.complianceFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.complianceFormRiskAssessmentValue) }}
            />
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.eighthSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.creditRiskManagementFormRiskAssessment
                          : data?.creditRiskManagementFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.creditRiskManagementFormRiskAssessmentDescription
                          : data?.creditRiskManagementFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.creditRiskManagementFormRiskAssessmentValue) }}
            />
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.ninthSectorHeader')}
                        riskLevel={lang === 'mne' ? data?.bankRiskProfileFormRiskAssessment
                          : data?.bankRiskProfileFormRiskAssessmentEn}
                        riskDescription={lang === 'mne' ? data?.bankRiskProfileFormRiskAssessmentDescription
                          : data?.bankRiskProfileFormRiskAssessmentDescriptionEn}
                        style={{ color: getRiskColor(data?.bankRiskProfileFormRiskAssessmentValue) }}
            />
        </Col>
        <Col className="col-12">
            <SectorInfo header={t('externalization.riskLevelSum.tenthSectorHeader')}
                        riskLevel={getMaxRiskLevelInfo().riskLevel}
                        riskDescription={getMaxRiskLevelInfo().riskDescription}
                        style={{ color: getRiskColor(getMaxRiskLevelInfo().riskValue)}}
            />
        </Col>
        </div>
    </>
    );
};

export default RiskLevelSum;
